import React from "react";
import cn from "classnames";
import { Form } from "./form";
import { useUI } from "../context";
import { Product } from "./product";

export const Content = () => {
  const { activeStep } = useUI();

  return (
    <div className="pb-[140px] pt-6 lg:pt-10">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="col-span-3 max-lg:hidden">
            <Product />
          </div>

          <div
            className={cn("lg:pl-10 lg:border-l-[1px] border-gray-modern-300 lg:col-span-8", {
              "border-none": activeStep === 4,
            })}
          >
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
};
